// Outcomes of a sign-in. The submit click itself is the sheet's
// onboarding-sign-in-submit-click (onboarding-events.js).
export const auth_events = {
  partner_login_success: {
    category: 'Partner portal sign-in',
    action: 'Operator is signed in',
    label: 'partner_login_success',
  },
  partner_login_failure: {
    category: 'Partner portal sign-in',
    action: 'Sign-in is refused',
    label: 'partner_login_failure',
  },
  partner_login_mfa_required: {
    category: 'Partner portal sign-in',
    action: 'Password accepted, a one-time code is sent',
    label: 'partner_login_mfa_required',
  },
  partner_login_otp_failure: {
    category: 'Partner portal sign-in',
    action: 'One-time code is refused',
    label: 'partner_login_otp_failure',
  },
  partner_login_otp_resend: {
    category: 'Partner portal sign-in',
    action: 'Operator asks for another one-time code',
    label: 'partner_login_otp_resend',
  },
  partner_password_change_success: {
    category: 'Partner portal password',
    action: 'Operator sets a new password',
    label: 'partner_password_change_success',
  },
  partner_password_change_failure: {
    category: 'Partner portal password',
    action: 'New password is refused',
    label: 'partner_password_change_failure',
  },
  partner_branch_switch: {
    category: 'Partner portal session',
    action: 'Operator switches to another branch',
    label: 'partner_branch_switch',
  },
  partner_logout: {
    category: 'Partner portal session',
    action: 'Operator signs out',
    label: 'partner_logout',
  },
};
